module.exports = __webpack_public_path__ + "static/media/chase_the_heart.2fb812f7.png";